import { FlightInfo } from '@flysas-tech/book-value-stream-models';
import { Array, Object, Optional, Record, Static, String, Boolean } from '@sinclair/typebox';

import { FlightOffersMode } from '../../constants';
import { StringEnumSchema } from '../../utils/types';
import { UnionEnum } from '../../utils/unionEnum';
import { CodeName } from '../sas-domain/common';
import { FareRules } from '../sas-domain/fareRules';
import { Coupon } from '../sas-domain/pointsPricing';

import { AssociationMatrix } from './associationsMatrix';
import { FaresMap } from './faresMap';

export type FlightSegment = Static<typeof FlightSegment>;
export const FlightSegment = Object({
  id: String(),
  lookupId: String(),
  flightNumber: String(),
  departure: FlightInfo,
  arrival: FlightInfo,
  airCraft: CodeName,
  marketingCarrier: CodeName,
  operatingCarrier: CodeName,
});

export type Product = Static<typeof Product>;
const Product = Object({
  id: String(),
  name: String(),
  cabin: String(),
  cabinCode: String(),
  fareFamilyName: String(),
  isPopularChoice: Optional(Boolean()),
  dictionaries: Object({
    segmentBookingClass: Record(String(), String()),
    segmentFareClass: Record(String(), String()),
  }),
});

export type Flight = Static<typeof Flight>;
export const Flight = Object({
  id: String(),
  boundType: UnionEnum(['OUTBOUND', 'INBOUND']),
  segments: Array(FlightSegment),
  products: Array(Product),
  isCodeShare: Boolean(),
});

export type FlightSearchResponse = Static<typeof FlightSearchResponse>;
export const FlightSearchResponse = Object({
  offerId: String(),
  type: UnionEnum(['points', 'revenue']),
  outboundFlights: Array(Flight),
  inboundFlights: Optional(Array(Flight)),
  coupons: Optional(Array(Coupon)),
  associationsMatrix: Optional(AssociationMatrix),
  faresMap: FaresMap,
  fareRules: Record(String(), FareRules),
  flightOfferMode: StringEnumSchema(FlightOffersMode),
});
